import { useSelector } from 'store/utils';

const useIsExternalVacancy = (): boolean =>
    useSelector(
        (state) => state.createCampaign.campaignVacancyId === null && state.createBanner.bannerVacancyId === null
    );

export default useIsExternalVacancy;
